import i18n from 'modules/core/lib/i18n'

export const getTimeoffDefaultsLabel = (type: string) => {
  switch (type) {
    case 'caring_dependents':
      return i18n.t('settings.leave_types.defaults.caring_dependents')
    case 'compassionate':
      return i18n.t('settings.leave_types.defaults.compassionate')
    case 'congress':
      return i18n.t('settings.leave_types.defaults.congress')
    case 'custom':
      return i18n.t('settings.leave_types.defaults.custom')
    case 'doctors_appointment':
      return i18n.t('settings.leave_types.defaults.doctors_appointment')
    case 'exams':
      return i18n.t('settings.leave_types.defaults.exams')
    case 'family_day':
      return i18n.t('settings.leave_types.defaults.family_day')
    case 'family_illness':
      return i18n.t('settings.leave_types.defaults.family_illness')
    case 'generic':
      return i18n.t('settings.leave_types.defaults.generic')
    case 'holiday':
      return i18n.t('settings.leave_types.defaults.holiday')
    case 'jury_duty':
      return i18n.t('settings.leave_types.defaults.jury_duty')
    case 'marriage':
      return i18n.t('settings.leave_types.defaults.marriage')
    case 'maternity':
      return i18n.t('settings.leave_types.defaults.maternity')
    case 'medical_leave':
      return i18n.t('settings.leave_types.defaults.medical_leave')
    case 'military_service':
      return i18n.t('settings.leave_types.defaults.military_service')
    case 'moving_house':
      return i18n.t('settings.leave_types.defaults.moving_house')
    case 'other':
      return i18n.t('settings.leave_types.defaults.other')
    case 'overtime_compensation':
      return i18n.t('settings.leave_types.defaults.overtime_compensation')
    case 'paid_unspecified_leave':
      return i18n.t('settings.leave_types.defaults.paid_unspecified_leave')
    case 'parental':
      return i18n.t('settings.leave_types.defaults.parental')
    case 'paternity':
      return i18n.t('settings.leave_types.defaults.paternity')
    case 'personal_day':
      return i18n.t('settings.leave_types.defaults.personal_day')
    case 'sabbatical':
      return i18n.t('settings.leave_types.defaults.sabbatical')
    case 'sick':
      return i18n.t('settings.leave_types.defaults.sick')
    case 'study_day':
      return i18n.t('settings.leave_types.defaults.study_day')
    case 'training':
      return i18n.t('settings.leave_types.defaults.training')
    case 'unpaid_unspecified_leave':
      return i18n.t('settings.leave_types.defaults.unpaid_unspecified_leave')
    case 'wfh':
      return i18n.t('settings.leave_types.defaults.wfh')
    case 'work_travel':
      return i18n.t('settings.leave_types.defaults.work_travel')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}
